import api from "../../../../app/api";
import {Bundle} from "../BundlesApi";


export interface ManagePaymentsForm {
  billing_first_name: string;
  billing_last_name: string;
  billing_street: string;
  billing_city: string;
  billing_country: string;
  billing_state: string;
  billing_zip: string;
  billing_phone: string;
}

export async function getPaymentInformation() {
  interface AccountViewData {
    name: string;
    billing_first_name: string;
    billing_last_name: string;
    billing_street: string;
    billing_city: string;
    billing_country: string;
    billing_state: string;
    billing_zip: string;
    billing_phone: string;
    created_at: string;
  }

  const response = await api.get<{ success: boolean; data: AccountViewData; message: string }>(
    `/account/view`,
  );
  const data = response.data.data;

  return {
    billing_first_name: data.billing_first_name,
    billing_last_name: data.billing_last_name,
    billing_street: data.billing_street,
    billing_city: data.billing_city,
    billing_country: data.billing_country,
    billing_state: data.billing_state,
    billing_zip: data.billing_zip,
    billing_phone: data.billing_phone,
  } as ManagePaymentsForm;
}

export async function updatePayments(item: ManagePaymentsForm) {
  return api.post("/account/update", { AccountForm: item })
}